import { useCallback, useState } from 'react';
import { useSearchList } from 'hooks';
import { SEARCH_REACTIONS } from '@control-front-end/common/constants/reactions';
import { DIRECTIONS } from 'constants';

const SETTINGS = {
  STEP: 15,
};

const useSearchReactions = (actorId) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  const { onScroll, loading, list, clearSearchList, makeSearch } =
    useSearchList({
      actionType: SEARCH_REACTIONS.REQUEST,
      searchParams: {
        actorId,
      },
      settings: { step: SETTINGS.STEP },
      skip: searchQuery?.length < 2,
      localState: true,
    });

  const clearSearch = useCallback(() => {
    setSearchQuery('');
    setActiveIndex(0);
    clearSearchList();
  });

  const performSearch = useCallback((query) => {
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return;
    setSearchQuery(trimmedQuery);
    makeSearch({ query: trimmedQuery });
  });

  const getNextReaction = useCallback(
    (direction) => {
      if (!list.length) return null;

      const nextIndex =
        direction === DIRECTIONS.UP
          ? Math.max(0, activeIndex - 1)
          : Math.min(list.length - 1, activeIndex + 1);

      // Only update if index actually changed
      if (nextIndex !== activeIndex) {
        setActiveIndex(nextIndex);
        return list[nextIndex];
      }

      return list[activeIndex];
    },
    [list, activeIndex]
  );

  return {
    // Data
    searchResults: list,
    activeIndex,
    searchQuery,

    // Computed state
    showLoader: loading,

    // Actions
    onScroll,
    getNextReaction,
    clearSearch,
    onSearch: performSearch,
  };
};

export default useSearchReactions;
